import { render } from "./Deci2frac.vue?vue&type=template&id=6182d814&scoped=true"
import script from "./Deci2frac.vue?vue&type=script&lang=js"
export * from "./Deci2frac.vue?vue&type=script&lang=js"

import "./Deci2frac.vue?vue&type=style&index=0&id=6182d814&scoped=true&lang=css"

import exportComponent from "E:\\VSProjects\\HTML\\quickcalculationpractice\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6182d814"]])

export default __exports__